import { SUMMARY_BREAKDOWN_SEPARATOR } from "./table.summary.constants"
import type { SummaryBreakdownEntry } from "./table.summary.types"
import {
  formatBreakdownEntry,
  getBreakdownEntryColor,
} from "./table.summary.utils"

export type TableSummaryBreakdownProps = {
  entries: SummaryBreakdownEntry[]
}

/**
 * A breakdown's entries in a line — "● 117× Activated · ● 43× Pending" —
 * each behind a dot in the colour of its segment in the stacked bar, so the
 * bar and the text read as one figure.
 */
function TableSummaryBreakdown(props: TableSummaryBreakdownProps) {
  const { entries } = props

  return entries.map((entry, index) => (
    <span key={entry.key} className="ui-table-summary-breakdown-entry">
      {index > 0 && SUMMARY_BREAKDOWN_SEPARATOR}
      <span
        className="ui-table-summary-dot"
        style={{ backgroundColor: getBreakdownEntryColor(index) }}
        aria-hidden
      />
      {formatBreakdownEntry(entry)}
    </span>
  ))
}

export default TableSummaryBreakdown
